import { render, staticRenderFns } from "./MySupportTicketCreate.vue?vue&type=template&id=4eefabe8"
import script from "./MySupportTicketCreate.vue?vue&type=script&lang=js"
export * from "./MySupportTicketCreate.vue?vue&type=script&lang=js"
import style0 from "./MySupportTicketCreate.vue?vue&type=style&index=0&id=4eefabe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports